module.exports = __webpack_public_path__ + "img/accident1SYJ.aa7afb2f.png";